"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../css/app.css");
require("@autoprog/theme/dist/theme.css");
/**
 * Renvoie le theme actuel entre 'dark', 'light' ou null.
 * @returns le thème actuel
 */
const getTheme = () => {
    return localStorage.getItem('Acadio_Theme');
};
/**
 * Applique le theme sur la page
 */
const applyTheme = () => {
    const theme = getTheme();
    const N_Body = document.querySelector('body');
    const N_HTML = document.querySelector('html');
    if (theme) {
        N_Body.setAttribute('data-acadio-theme', theme);
        N_HTML.style.colorScheme = theme;
    }
    else {
        N_Body.removeAttribute('data-acadio-theme');
    }
};
/**
 * Initialise le formattage du formulaire
 */
const initFormFormat = () => {
    const N_InputLogin = document.querySelector('#input-login');
    N_InputLogin.addEventListener('change', () => {
        N_InputLogin.value = N_InputLogin.value.trim();
    });
    N_InputLogin.addEventListener('input', () => {
        N_InputLogin.value = N_InputLogin.value.trim();
    });
    const N_InputMail = document.querySelector('#input-mail');
    N_InputMail.addEventListener('change', () => {
        N_InputMail.value = N_InputMail.value.trim();
    });
    N_InputMail.addEventListener('input', () => {
        N_InputMail.value = N_InputMail.value.trim();
    });
};
/**
 * Fonction d'initialisation principale
 */
const init = () => {
    applyTheme();
    initFormFormat();
};
init();
